import FavoriteList from './FavoriteList';
export default FavoriteList;
